import { useCallback, useEffect, useState } from "react";
import i18n from "src/i18n/config";
import { ga4DashboardService } from "src/services/GA4DashboardAPIs";
import type { ApiLang } from "src/utils/apiLang";
import type { KPICardData } from "../types/Kpi";

export function useKpiData(startDate: string, endDate: string, lang: ApiLang) {
  const [kpiData, setKpiData] = useState<KPICardData[]>([]);
  const [rawData, setRawData] = useState<unknown>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchKpiData = useCallback(async (start: string, end: string, language: ApiLang) => {
    setLoading(true);
    setError(null);
    setRawData(null);
    try {
      const response = await ga4DashboardService.fetchDashboardKPI({
        start_date: start,
        end_date: end,
        lang: language,
      });
      setRawData(response);
      if (response?.kpiData?.length) {
        setKpiData(response.kpiData);
      } else {
        setKpiData([]);
      }
    } catch (err) {
      setError(
        err instanceof Error ? err.message : i18n.t("webAnalytics.errors.loadKpiFailed")
      );
      setKpiData([]);
      setRawData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchKpiData(startDate, endDate, lang);
  }, [startDate, endDate, lang, fetchKpiData]);

  return { kpiData, rawData, loading, error };
}
